import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function AdminLogin() {
  const { login, formatErr } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("admin@texasbusinessdispute.com");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      await login(email.trim(), password);
      nav("/admin");
    } catch (e2) {
      setErr(formatErr(e2));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="login-shell" data-testid="admin-login-page">
      <div className="login-card">
        <div className="intake-eyebrow">TexasBusinessDispute.com · Internal</div>
        <h2 className="serif" style={{ fontSize: 26, fontWeight: 600, margin: "0 0 8px", letterSpacing: "-0.02em" }}>Admin sign-in</h2>
        <p style={{ fontSize: 13.5, color: "var(--muted)", marginBottom: 24 }}>Access the qualified case dashboard.</p>

        <form onSubmit={submit}>
          <div className="frow">
            <label>Email</label>
            <input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="admin@texasbusinessdispute.com" />
          </div>
          <div className="frow">
            <label>Password</label>
            <input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" />
          </div>
          {err && <div data-testid="login-error" style={{ marginBottom: 10, color: "#b73b2a", fontSize: 12, fontFamily: "var(--mono)" }}>{err}</div>}
          <button data-testid="login-submit-btn" className="btn-copper" type="submit" disabled={busy} style={{ width: "100%" }}>
            {busy ? <><Loader2 size={14} className="animate-spin" /> Signing in...</> : "Sign in →"}
          </button>
        </form>

        <div style={{ marginTop: 22, textAlign: "center" }}>
          <Link to="/" style={{ fontFamily: "var(--mono)", fontSize: 11, color: "var(--muted)", textDecoration: "none", letterSpacing: ".12em" }} data-testid="login-back-home">← BACK TO SITE</Link>
        </div>
      </div>
    </div>
  );
}
